import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить данные по городам
  async loadCities ({ commit }) {
    var data=null;
    try{
      data = await api.Get("DirectoryService/City");
      commit('loadCities', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //добавить
  async addCity({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      newId = await api.Post("DirectoryService/City", data);
      if (newId != null) {
        var getparams = '?Id=' + newId.id;
        newData = await api.Get("DirectoryService/City/GetById" + getparams)
      }
      if (newData != null && newData != "")
        commit('addCity', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //редактировать
  async editCity({commit}, data) {
    var newData = null;
    var newId = null;
    try {
      await api.Put("DirectoryService/City", data);
      var getparams = '?Id=' + data.id;
      newData = await api.Get("DirectoryService/City/GetById" + getparams)

      if (newData != null && newData != "")
        commit('editCity', newData);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //удалить
  async deleteCity({commit}, cityId) {
    try {
      var getparams = '?CityId=' + cityId;
      await api.Delete("DirectoryService/City", getparams);
      commit('deleteCity',cityId);
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },


}
